import { render, staticRenderFns } from "./putInStorage.vue?vue&type=template&id=b981ad5e"
import script from "./putInStorage.vue?vue&type=script&lang=js"
export * from "./putInStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports